import React from 'react';

const InputRazaoSocial = ({
  id,
  className,
  name,
  label,
  inputRef,
  errors,
  control,
  watch,
  legenda,
  ...rest
}) => {
  const allowedKeys = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Tab',
  ];
  const handleKeyDown = (event) => {
    const isBlockedChar =
      event.key.length === 1 && /[\u00C0-\u00FF]/.test(event.key); // apenas letras acentuadas e ç entram aqui

    if (!allowedKeys.includes(event.key) && isBlockedChar) {
      event.preventDefault(); // bloqueia só os acentos e ç
    }
  };
  const handleChange = (event) => {
    // remove acentos e ç se o usuário colar texto
    event.target.value = event.target.value
      .normalize('NFD')
      .replace(/[\u0300-\u036fçÇ]/g, '');
  };
  const msgErro = errors && errors[name]?.message;
  return (
    <div className={`campo-txt ${msgErro ? 'erro' : ''}`}>
      <label className={`subtitulo-p`} htmlFor={id}>
        {label}
      </label>

      <div className="input-container">
        <input
          type={'text'}
          id={id}
          name={name}
          ref={inputRef}
          className={msgErro ? 'invalid' : ''}
          onKeyDown={handleKeyDown}
          onChange={handleChange}
          {...rest}
        />
      </div>
      <div className="mensagem legenda">{msgErro}</div>
    </div>
  );
};

export default InputRazaoSocial;
